import type { TechniqueDefinition } from "./TechniqueDefinition.js";

export const ilusaoDoMedo: TechniqueDefinition = {
  id: "ilusao_do_medo",
  name: "Ilusão do Medo",
  description:
    "Inflicts temporary fear and a separate offensive debuff on an enemy.",
  family: "genjutsu",
  proficiency: "genjutsu",
  targeting: "single_hostile",
  behavior: { kind: "control" },
  levels: {
    1: {
      chakraCost: 24,
      cooldownMs: 12_000,
      range: 180,
      maxTargets: 1,
      power: 0,
      attackCoefficient: 1,
      control: {
        fearMs: 1_400,
        potency: 4,
        damageReduction: 0.08,
        debuffMs: 6_000,
      },
    },
    2: {
      chakraCost: 25,
      cooldownMs: 12_000,
      range: 180,
      maxTargets: 1,
      power: 0,
      attackCoefficient: 1,
      control: {
        fearMs: 1_450,
        potency: 5,
        damageReduction: 0.09,
        debuffMs: 6_200,
      },
    },
    3: {
      chakraCost: 26,
      cooldownMs: 12_000,
      range: 180,
      maxTargets: 1,
      power: 0,
      attackCoefficient: 1,
      control: {
        fearMs: 1_500,
        potency: 6,
        damageReduction: 0.1,
        debuffMs: 6_400,
      },
    },
    4: {
      chakraCost: 26,
      cooldownMs: 12_000,
      range: 180,
      maxTargets: 1,
      power: 0,
      attackCoefficient: 1,
      control: {
        fearMs: 1_550,
        potency: 8,
        damageReduction: 0.11,
        debuffMs: 6_600,
      },
    },
    5: {
      chakraCost: 27,
      cooldownMs: 12_000,
      range: 180,
      maxTargets: 1,
      power: 0,
      attackCoefficient: 1,
      control: {
        fearMs: 1_600,
        potency: 10,
        damageReduction: 0.12,
        debuffMs: 6_800,
      },
    },
    6: {
      chakraCost: 28,
      cooldownMs: 12_000,
      range: 180,
      maxTargets: 1,
      power: 0,
      attackCoefficient: 1,
      control: {
        fearMs: 1_700,
        potency: 11,
        damageReduction: 0.13,
        debuffMs: 7_000,
      },
    },
    7: {
      chakraCost: 29,
      cooldownMs: 12_000,
      range: 180,
      maxTargets: 1,
      power: 0,
      attackCoefficient: 1,
      control: {
        fearMs: 1_750,
        potency: 12,
        damageReduction: 0.14,
        debuffMs: 7_200,
      },
    },
    8: {
      chakraCost: 30,
      cooldownMs: 12_000,
      range: 180,
      maxTargets: 1,
      power: 0,
      attackCoefficient: 1,
      control: {
        fearMs: 1_850,
        potency: 14,
        damageReduction: 0.145,
        debuffMs: 7_500,
      },
    },
    9: {
      chakraCost: 30,
      cooldownMs: 12_000,
      range: 180,
      maxTargets: 1,
      power: 0,
      attackCoefficient: 1,
      control: {
        fearMs: 1_900,
        potency: 15,
        damageReduction: 0.15,
        debuffMs: 7_800,
      },
    },
    10: {
      chakraCost: 31,
      cooldownMs: 12_000,
      range: 180,
      maxTargets: 1,
      power: 0,
      attackCoefficient: 1,
      control: {
        fearMs: 2_000,
        potency: 16,
        damageReduction: 0.16,
        debuffMs: 8_000,
      },
    },
  },
  visual: { effectId: 836, statusEffectId: 2899 },
};
